<div class=" contact-us contact app-primary-bg">
    <div class="pt-110">
        <div class="text-center">
            <h1>Contact Us</h1>
        </div>
        <div class="container">
            <div class="row justify-content-center pl-10 pt-30">
                <div class="col-12 col-md-5 box">
                    <form [formGroup]="registerForm" autocomplete="off">
                        <mat-form-field class="w-100">
                            <mat-label>Your Name</mat-label>
                            <input matInput formControlName="name" required maxlength="35" allowValues
                                isInputType="onlyChar">
                            <mat-error *ngIf="registerForm.get('name').hasError('required')">
                                Please enter your name
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-100">
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="email" required maxlength="255">
                            <mat-error *ngIf="registerForm.get('email').hasError('required')">
                                Please enter email
                            </mat-error>
                            <mat-error
                                *ngIf="registerForm.get('email').hasError('email') || registerForm.get('email').hasError('pattern')">
                                Please enter valid email
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-100 country-flag-txt">
                            <mat-label>Contact Number</mat-label>
                            <input matInput countryFlagPhone allowValues isInputType="phone" formControlName="phone"
                                required>
                            <mat-error *ngIf="registerForm.get('phone').hasError('required')">
                                Please enter phone number
                            </mat-error>
                            <mat-error *ngIf="!registerForm.get('phone').hasError('required') && 
                            registerForm.get('phone').hasError('isInvalid')">
                                Please enter valid phone number
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-100">
                            <mat-label>Organization Name</mat-label>
                            <input matInput formControlName="organization_name" allowValues isInputType="alphaNumeric">
                        </mat-form-field>
                        <mat-form-field class="w-100">
                            <mat-label>Leave a message</mat-label>
                            <textarea isInputType="onlyChar" matInput rows="4" formControlName="message"
                                required></textarea>
                            <mat-error *ngIf="registerForm.get('message').hasError('required')">
                                Please Leave a message
                            </mat-error>
                        </mat-form-field>

                        <div class="text-center mt-10">
                            <button mat-flat-button class="flat-primary-button secondary-bg-button" (click)="onSubmit()">Submit</button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
        <div class="sec-2">
            <div class="container txt-align pb-60">
                <div class="row justify-content-center ">
                    <div class="col-md-3">
                        <p><span>Headquarters</span><br>
                            {{clientDetails?.address?.line1}},<br>
                            {{clientDetails?.address?.line2}}, {{clientDetails?.address?.city}}, {{clientDetails?.address?.state}}<br>
                            {{clientDetails?.address?.zip}}
                        </p>
                    </div>
                    <div class="col-md-3">
                        <p><span>Email Us</span><br>
                            {{clientDetails?.info_mail}}

                        </p>
                    </div>
                    <div class="col-md-3">
                        <p>
                            <span><span class="text-capitalize">{{clientDetails?.slug}}</span> Support</span><br>
                            {{clientDetails?.support_mail}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="center center" >
        <div fxFlex="80%" class="cont-box mlr-10">
            <div fxLayout="row wrap" fxFlex="100%" fxLayoutAlign="start start" fxLayout.xs="column">
                <form [formGroup]="registerForm" autocomplete="off" fxLayout.xs="column"> -->
        <!-- <div fxFlex="60%" fxFlex.md="50" fxFlex.xs="100%"> -->
        <!-- <div fxLayout="row wrap" class="profile_basic" fxFlex="100%"
                            fxLayoutAlign="start center">
                            <div fxFlex="100%" fxFlex.xs="100%" class="pb-20">
                                <h1>Send us a Message</h1>
                            </div>
                            <div fxFlex="50%" fxFlex.xs="100%" class="pb-5 mb-1">
                                <mat-form-field class="w-100 ">
                                    <mat-label>Your Name</mat-label>
                                    <input matInput  formControlName="name" required
                                        maxlength="35" allowValues isInputType="alphaNumeric">
                                    <mat-error *ngIf="registerForm.get('name').hasError('required')">
                                        Please enter your name
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="50%" fxFlex.xs="100%" class="pb-5 mb-1 pl-20 phone-number-placeholder">
                                <span class="placeholder-label">Phone 
                                    <span
                                        [ngClass]="{'placeholder-label-required' : (registerForm.get('phone').hasError('required')) }">*</span>
                                </span>
                                <mat-form-field class="w-100 ">
                                    <input matInput countryFlagPhone allowValues isInputType="phone"
                                         formControlName="phone" required>
                                    <mat-error *ngIf="registerForm.get('phone').hasError('required')">
                                        Please enter phone number
                                    </mat-error>
                                    <mat-error *ngIf="!registerForm.get('phone').hasError('required') && 
                                    registerForm.get('phone').hasError('isInvalid')">
                                        Please enter valid phone number
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="100%" fxFlex.xs="100%" class="pb-5 mb-1">
                                <mat-form-field class="w-100 ">
                                    <mat-label>Email</mat-label>
                                    <input matInput formControlName="email" required maxlength="255">
                                    <mat-error *ngIf="registerForm.get('email').hasError('required')">
                                        Please enter email
                                    </mat-error>
                                    <mat-error *ngIf="registerForm.get('email').hasError('email')">
                                        Please enter valid email
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="100%" fxFlex.xs="100%" class="pb-5 pt-10">
                                <mat-form-field class="w-100">
                                    <mat-label>Organization Name</mat-label>
                                    <input matInput formControlName="organization_name">
                                </mat-form-field>
                            </div>
                            <div fxFlex="100%" fxFlex.xs="100%" class="pb-5 mb-1">
                                <mat-form-field class="w-100 ">
                                    <mat-label>Leave a message</mat-label>
                                    <textarea matInput rows="4" formControlName="message"
                                        required></textarea>
                                    <mat-error *ngIf="registerForm.get('message').hasError('required')">
                                        Please Leave a message
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="100%" fxFlex.xs="100%">
                                <button mat-flat-button class="theme-btn1 mr-10 mb-40 mt-3 pointer"
                                    (click)="onSubmit()">
                                    Send Message
                                </button>

                            </div>
                        </div> -->

        <!-- </div> -->

        <!-- <div fxFlex="40%" fxFlex.md="50" fxFlex.xs="100%" class="pl-85">
                        <div fxFlex="100%" fxFlex.xs="100%">
                            <h1 class="pb-20">Contact Information</h1>
                            <p class="fs-16 fw-500">Arevea TV Inc.</p>
                            <p class="pb-10"> -->
        <!-- <i class="fa fa-map-marker cont-icon" aria-hidden="true"></i>385 Moffett Park Drive, Suite 105,<br>Sunnyvale, CA 94089<br>
                                <br>
                                <i class="fa fa-phone cont-icon" aria-hidden="true"></i> Phone: 408 475 5906<br><br> -->
        <!-- <i class="fa fa-envelope cont-icon" aria-hidden="true"></i>Email: <span style="color:#fff;">support@arevea.com</span>
                            </p> -->
        <!-- <p class="pt-20 fs-16 fw-500 top-border">Arevea TV UK Ltd</p> -->
        <!-- <p> -->
        <!-- <i class="fa fa-map-marker cont-icon" aria-hidden="true"></i>291 Bounces Road, London N9 8LP<br> -->
        <!-- <br> -->
        <!-- <i class="fa fa-phone cont-icon" aria-hidden="true"></i> Phone: 07425588260<br><br> -->
        <!-- <i class="fa fa-envelope cont-icon" aria-hidden="true"></i>Email: <span style="color:#fff;">zay.powell@arevea.com</span></p> -->
        <!-- <p><i class="fa fa-map-marker cont-icon" aria-hidden="true"></i>3031 Tisch
                                Way, 110 Plaza West,<br>
                                San Jose, CA 95128<br><br>
                                <i class="fa fa-phone cont-icon" aria-hidden="true"></i> Phone: +1 (669)
                                247-6699<br><br>
                                <i class="fa fa-envelope cont-icon" aria-hidden="true"></i>email: abc@xyz.com</p> -->
        <!-- <div class="Fsocial mt-2"> -->
        <!-- <a matTooltipPosition="above" matTooltip="Facebook"
                                    href="https://www.facebook.com/Areveatv-111754950520279/" target="_blank">
                                    <i class="fa fa-facebook-f"></i>
                                </a> -->
        <!-- <a href=""><i class="fa fa-facebook-f"></i></a> -->
        <!-- <a matTooltipPosition="above" matTooltip="Twitter"
                                    href="https://twitter.com/areveatv" target="_blank">
                                    <i class="fa fa-twitter"></i>
                                </a> -->
        <!-- <a href=""><i class="fa fa-twitter"></i></a> -->
        <!-- <a matTooltipPosition="above" matTooltip="Instagram"
                                    href="https://www.instagram.com/areveatv/" target="_blank">
                                    <i class="fa fa-instagram"></i>
                                </a> -->
        <!-- <a href=""><i class="fa fa-linkedin"></i></a> -->
        <!-- </div>

                        </div>
                    </div> -->
        <!-- </form> -->
        <!-- </div>
        </div>

    </div> -->


    </div>
</div>